export default "__VITE_ASSET__f2092f26__"